import StepBaseService from "../stepBase";
import StepBusinessType from "../stepBase/stepBusinessType";

class ApplyPMPExcludedStepService extends StepBaseService {
  // @ts-ignore
  getPrimaryProcedureOwnerStepKey = () => {
    return StepBusinessType.primaryProcedureOwner;
  };

  // @ts-ignore
  getProcedureOwnerStepKey = () => {
    return StepBusinessType.procedureOwner;
  };

  // @ts-ignore
  getPMPExcludedStepKey = () => {
    return {
      dataKey: StepBusinessType.pmpExcluded.dataKey,
      settingKey: "getApplyPmpExcludedStepItem",
    };
  };

  // @ts-ignore
  getTaskInfoKey = () => {
    return StepBusinessType.taskInfo;
  };

  // @ts-ignore
  getFlowStepData = () => null;
}
export default new ApplyPMPExcludedStepService();
